/*
 * @Author: 李吉涛 viclee25@126.com
 * @Date: 2023-11-09 11:09:32
 * @LastEditors: 李吉涛 viclee25@126.com
 * @LastEditTime: 2025-03-18 00:18:15
 * @FilePath: /locals-activity-react-web/src/config/env-config.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const env = process.env.BUILD_ENV || 'prod'

let envConfig = {
    dev: {
        api: 'https://dev.localhome.cn/api',
        // apiBoost: 'http://192.168.1.155:7001/api',
        apiBoost: 'https://i.localhome.cn/api',
        imgPrefix: 'http://f.localhome.cn', //房源图片
        newImagePrefix: 'http://locals-house-test.oss-cn-shenzhen.aliyuncs.com', //上传图片
        pcUrl: 'http://tp.localhome.cn:9094', //pc官网
        mobileURL: 'http://tp.localhome.cn:9095', //移动端官网
        designImagePrefix: 'http://qy.localhome.com.cn/locals', // 签名图片
        walletUrl: (token) => `http://tp.localhome.cn:9090/newaccounting/wallet/index/${token}/AAA/story`, // 钱包地址
        // fileUrl:'http://192.168.0.215:9092'
        fileUrl: 'http://locals-house-test.oss-cn-shenzhen.aliyuncs.com',
        wxShareUrl: 'https://f.localhome.cn/devInsurance',
        activityId: '1904222209237',
        accessKeyId: 'IDsiKFg1XUYqPhBMHVwFRTVGWV8AOntA',
        accessKeySecret: 'OlkQGCE1bkQ/VgpUEScpNjIzaQdRFE5iaWhmXEJf'
    },
    test: {
        api: 'http://test.localhome.cn/api',
        imgPrefix: 'http://f.localhome.cn',
        newImagePrefix: 'http://locals-house-test.oss-cn-shenzhen.aliyuncs.com',
        pcUrl: 'http://tp.localhome.cn:7094', //pc官网
        mobileURL: 'http://tp.localhome.cn:7095', //移动端官网
        designImagePrefix: 'http://qy.localhome.com.cn/locals',
        walletUrl: (token) => `http://tp.localhome.cn:7090/newaccounting/wallet/index/${token}/AAA/story`, // 钱包地址
        // fileUrl:'http://192.168.0.215:9092'
        fileUrl: 'http://locals-house-test.oss-cn-shenzhen.aliyuncs.com', //临时下载文件地址 到时候改测试的
        wxShareUrl: 'https://f.localhome.cn/testInsurance',
        accessKeyId: 'IDsiKFg1XUYqPhBMHVwFRTVGWV8AOntA',
        accessKeySecret: 'OlkQGCE1bkQ/VgpUEScpNjIzaQdRFE5iaWhmXEJf'
    },
    pre: {
        api: 'http://pre.localhome.cn/api',
        imgPrefix: 'http://locals-house-prod.oss-cn-shenzhen.aliyuncs.com',
        newImagePrefix: 'http://locals-house-prod.oss-cn-shenzhen.aliyuncs.com',
        pcUrl: 'http://tp.localhome.cn:6094', //pc官网
        mobileURL: 'http://tp.localhome.cn:6095', //移动端官网
        designImagePrefix: 'http://qytest.localhome.com.cn/locals',
        walletUrl: (token) => `http://tp.localhome.cn:6090/newaccounting/wallet/index/${token}/AAA/story`, // 钱包地址
        // fileUrl:'http://192.168.0.215:9092'
        fileUrl: 'http://locals-house-prod.oss-cn-shenzhen.aliyuncs.com', //临时下载文件地址 到时候改测试的
        wxShareUrl: 'https://f.localhome.cn/preInsurance',
        accessKeyId: 'IDsiKFg1XUYqPhBMHVwFRTVGWV8AOntA',
        accessKeySecret: 'OlkQGCE1bkQ/VgpUEScpNjIzaQdRFE5iaWhmXEJf'
    },
    prod: {
        api: 'https://ms.localhome.cn/api',
        apiBoost: 'https://i.localhome.cn/api',
        imgPrefix: 'http://locals-house-prod.oss-cn-shenzhen.aliyuncs.com', //线上房源图片
        newImagePrefix: 'http://locals-house-prod.oss-cn-shenzhen.aliyuncs.com',
        designImagePrefix: 'http://qy.localhome.com.cn/locals',
        fileUrl: 'http://locals-house-prod.oss-cn-shenzhen.aliyuncs.com',
        walletUrl: (token) => `http://mobile.localhome.com.cn/newaccounting/wallet/index/${token}/AAA/story`, // 钱包地址
        wxShareUrl: 'http://f.localhome.cn/insurance',
        accessKeyId: 'IDsiKFg1XUYqPhBMHVwFRTVGWV8AOntA',
        accessKeySecret: 'OlkQGCE1bkQ/VgpUEScpNjIzaQdRFE5iaWhmXEJf'
    }
}

envConfig = envConfig[env]

export default {
    envConfig
}
